import React from 'react';
import ReactDOM from 'react-dom';
import LandingPage from './containers/landingPage';
import ErrorPage from './containers/errorPage';
import TransitPage from './containers/transitPage';
import PitchPage from './containers/pitchPage';
import FeaturesPage from './containers/featuresPage';
import PricingPage from './containers/pricingPage';
import FQandAPage from './containers/fqandaPage';
import { Provider } from 'react-redux';
import configureStore from './configureStore';
import { Router, Route , browserHistory , Redirect , IndexRedirect } from 'react-router';
import '../semantic/dist/semantic.min.css';

const store  = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <Router history={browserHistory}>
      <Route path="/" component={LandingPage}>
        <IndexRedirect to="/home" />
        <Route path="/home" component={PitchPage}/>
        <Route path="/features" component={FeaturesPage}/>
        <Route path="/pricing" component={PricingPage}/>
        <Route path="/fqanda" component={FQandAPage}/>
        <Route path="/transit" component={TransitPage}/>
        <Route path="*" component={ErrorPage}/>
      </Route>
    </Router>
  </Provider>,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/